export default "__VITE_ASSET__CURdLYJU__"